import React from 'react';
import PrintInscription from './PrintInscription';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';

interface DialogInscriptionProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  detailData: any;
  patientInfo: any;
  fontSizeScaleSurgery: number;
  fontSizeScaleAnesthesia: number;
  handleChangeData: (field: string, value: number) => void;
}

const DialogInscription: React.FC<DialogInscriptionProps> = ({
  open,
  onClose,
  onConfirm,
  detailData,
  patientInfo,
  fontSizeScaleSurgery,
  fontSizeScaleAnesthesia,
  handleChangeData
}) => {

  const increaseTextSize = (name: string, fontSizeScale: number) => {
    handleChangeData(name, fontSizeScale + 1);
  }
  const decreaseTextSize = (name: string,fontSizeScale: number) => {
    handleChangeData(name, fontSizeScale - 1);
  }

  return (
    <Dialog open={open} onClose={onClose} sx={{
      "& .MuiDialog-paper": {
        maxWidth: "none",
        maxHeight: "none",
        width: "297mm",
      },
    }}>
      <DialogContent
        sx={{
          width: '297mm',
          height: '210mm',
          border: '1px solid #000',
          overflow: 'hidden',
          padding: '0',
        }}>
        <PrintInscription
          detailData={detailData}
          patientInfo={patientInfo}
          fontSizeScaleSurgery={fontSizeScaleSurgery}
          fontSizeScaleAnesthesia={fontSizeScaleAnesthesia}
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mr:2 }}>
          <Typography sx={{ mr: 1 }}>施術文字サイズ調整:</Typography>
          <Button onClick={() => decreaseTextSize('fontSizeScaleSurgery', fontSizeScaleSurgery)} variant="contained" size="small" sx={{ mr: 1 }}>
            - 小さく
          </Button>
          <Button onClick={() => increaseTextSize('fontSizeScaleSurgery', fontSizeScaleSurgery)} variant="contained" size="small">
            + 大きく
          </Button>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography sx={{ mr: 1 }}>麻酔文字サイズ調整:</Typography>
          <Button onClick={() => decreaseTextSize('fontSizeScaleAnesthesia', fontSizeScaleAnesthesia)} variant="contained" size="small" sx={{ mr: 1 }}>
            - 小さく
          </Button>
          <Button onClick={() => increaseTextSize('fontSizeScaleAnesthesia', fontSizeScaleAnesthesia)} variant="contained" size="small">
            + 大きく
          </Button>
        </Box>
        <Box sx={{ position: 'absolute', right: 20 }}>
          <Button onClick={onClose}>キャンセル</Button>
          <Button onClick={onConfirm} variant="contained">
            確定
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default DialogInscription;
